export const $document = $(document);
export const $window = $(window);
export const $body = $(document.body);
export const LIVE_ADMIN = $body.hasClass('LiveAdminOn');